import React, { useState, useEffect } from 'react';
import { Box } from "@mui/material";
// import detailimg from "../../assests/detailimg.png";
// import detailimg1 from "../../assests/detailimg1.png";
// import detailimg2 from "../../assests/detailimg2.png";
// import detailimg3 from "../../assests/detailimg3.png";


const ProductImages = ({ images }) => {
    // const imgs = [detailimg, detailimg1, detailimg2, detailimg3];
    // Initialize mainImg state with the first image from imgs
    const [mainImg, setMainImg] = useState();
    // console.log(imgs, "mainimggg:" + mainImg);
    useEffect(() => {
        if (images && images.length > 0) {
            setMainImg(images[0]);
        }
    }, [images]);

    return (
        <div style={{ width: "100%" }}>
            <Box sx={{
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
            }}>
                <Box
                    sx={{
                        display: "flex",
                        gap: "20px",
                        flexDirection: "column",
                        "& figure": {
                            width: "90px",
                            height: "90px",
                            background: "rgba(247, 245, 245, 1)",
                            padding: "8px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                            "& img": {
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }
                        }
                    }}
                >
                     {(images || []).map((currImg, i) => {
                        return (
                            <figure key={i}>
                                <img
                                    src={currImg}
                                    onClick={() => setMainImg(currImg)}
                                    alt={`"Product Image" ${i + 1}`}
                                    // alt="productimg"
                                />
                            </figure>
                        );
                    })}
                </Box>
                <Box sx={{
                    minHeight: { xs: "290px", sm: "290px", md: "300px", lg: "340px" },
                    backgroundColor: "rgba(247, 245, 245, 1)",
                    padding: { xs: "15px", sm: "18px", md: "20px", lg: "25px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width:"100%",
                }}>
                    {mainImg ? (
                        <img src={mainImg} alt="Product" style={{ width: '100%', height: 'auto' }} />

                    ) : (
                        <>UNDEFINED</>
                    )}
                </Box>

            </Box>
        </div>
    );
};

export default ProductImages;
